<script lang="ts">
import { defineComponent, onBeforeMount, ref, watchEffect } from 'vue';
import { useRoute } from 'vue-router';

import { initLogin, commonParams, getUserInfo } from '@/common/utils';
import { useCommonStore } from '@/store/common';
import { checkBridge, runBridge } from '@/common/jsBridgeUtils';
import HeaderNavBar from '@/components/HeaderNavBar.vue';
import { checkLogin } from '@/common/login';
import { setUserInfoData } from '@/common/commonInfo';

export default defineComponent({
  name: 'App',
  components: {
    HeaderNavBar
  },
  setup() {
    const route = useRoute();
    const display = ref(false);
    const transferFlag = ref(['/vehicle/transfer'].includes(route.path));
    const commonStore = useCommonStore();

    watchEffect(() => {
      const { path } = route;

      if (path === '/') return;
      transferFlag.value = ['/vehicle/transfer'].includes(path);
      if (transferFlag.value) {
        if (checkBridge('setNavigationBarStyle')) {
          runBridge('setNavigationBarStyle', {
            hideNavBar: 0
          });
        }
      } else if (checkBridge('setNavigationBarStyle')) {
        runBridge('setNavigationBarStyle', {
          hideNavBar: 1
        });
      }
    });

    onBeforeMount(async () => {
      // 测试页面过滤校验
      if (window.location.href.includes('#/test')) {
        display.value = true;
        return;
      }

      const { ticket = '' } = (await getUserInfo()) || {};

      setUserInfoData({
        ticket
      });

      const commonQuerys = commonParams();

      initLogin();
      if (!commonQuerys?.ticket) {
        checkLogin(async () => {
          if (window.location.href.includes('#/driver')) {
            await commonStore.getBillSwitch(); // 新资金流开关
          }
          display.value = true;
        });
      } else {
        if (window.location.href.includes('#/driver')) {
          await commonStore.getBillSwitch(); // 新资金流开关
        }
        display.value = true;
      }
    });

    return {
      display,
      transferFlag
    };
  }
});
</script>

<template>
  <header-nav-bar v-if="!transferFlag" />
  <div
    :class="{
      'app-content': true,
      transfer: transferFlag
    }"
  >
    <router-view v-if="display"></router-view>
  </div>
</template>

<style lang="less">
* {
  box-sizing: border-box;
}
.app-content {
  position: relative;
  height: calc(~'100% - 1.12rem');
  overflow-y: scroll;
  &.transfer {
    height: 100%;
  }
}
</style>
